<template>
    <v-dialog
        v-model="deleteResponseCodeDialog"
        persistent
        width="500"
    >
        <template v-slot:activator="{ attrs }">
            <v-btn
                v-if="modelType==='DeleteBtn'"
                class="delete-btn"
                outlined
                light
                @click="openDialog"
            >
                Delete
            </v-btn>
            <v-icon
                v-if="modelType==='DeleteIcon'"
                class="cp"
                v-bind="attrs"
                @click="openDialog"
            >
                mdi-delete
            </v-icon>
        </template>
        <v-card id="delete_response_code_dialog">
            <v-card-title class="text-h5 lighten-2">
                <span>Delete</span>
            </v-card-title>
            <v-divider />
            <v-card-text>
                <div class="mt-5">
                    Are you sure you want to delete <b>{{ responseCode.response_code }}</b> form the Response code list?
                </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn
                    style="text-transform: none !important;"
                    outlined
                    light
                    @click="closedDialog"
                >
                    Cancel
                </v-btn>
                <v-btn
                    style="text-transform: none !important"
                    depressed
                    color="primary"
                    @click="deleteResponseCode"
                >
                    Delete
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>    
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';

export default {
    name: 'DeleteResponseCode',
    props: {
        modelType: {
            type: String,
            required: true
        },
        responseCode: {
            type: Object,
            required: true
        }
    },
    data: () => ({
        deleteResponseCodeDialog: false,
    }),
    methods: {
        closedDialog() {
            this.deleteResponseCodeDialog = false;
        },
        openDialog() {
            this.deleteResponseCodeDialog = true;
            this.$emit('closed-dialog');
        },
        async deleteResponseCode() {
            this.responseCode.operation = 'delete';
            let result = await webtmsBackend.deleteResponseCode(this.responseCode);
            if(result.result === 'OK') {
                this.$store.commit('SET_COMPANY_RESPONSE_CODES', result.companyResponseCodes);
                this.$store.commit('SET_COMPANY_RESPONSE_MAP', result.companyPositiveResponseMap);
                this.$store.dispatch('setSnackbar', { text: 'Response code deleted successfully!' });
                this.closedDialog();
            }
            if(result.err) {
                this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
            }
        }
    }
};
</script>
<style>
</style>